/**
 * Faq
 * ======================================
 * - toggle [hidden] attribute on [data-toggle] selector
 * - toggle ELEMENT_LABEL text with [data-toggle-label] attribute
 */

const ELEMENTS = ".js-faq .points__item-header";
const TOGGLE_CLASS = "is-active";

class Faq {
  constructor() {
    this.elements = document.querySelectorAll(ELEMENTS);

    if (!this.elements) {
      return false;
    }

    this.elements.forEach((el) => {
      el.addEventListener("click", this.toggle);
    });
  }

  toggle = (e) => {
    const el = e.currentTarget;
    const target = el.parentNode;

    target.classList.toggle(TOGGLE_CLASS);

    e.preventDefault();
  };
}

new Faq();
